module.exports = __webpack_public_path__ + "static/media/img3-3.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/melon/nutricheck_foliar/CA/img3-3.png
// module id = 1839
// module chunks = 3